<template>
  <v-sheet>
    <v-slide-group
      show-arrows
    >
      <template v-slot:next>
        <v-icon size="60">mdi-chevron-right</v-icon>
      </template>
      <template v-slot:prev>
        <v-icon size="60">mdi-chevron-left</v-icon>
      </template>
      <v-slide-item
        disabled
        v-for="(detail, key) in details"
        :key="key"
      >
        <v-card
          rounded="0"
          class="mx-5"
          min-height="350"
          width="300"
          color="transparent"
          outlined
        >
          <v-img
            :src="detail.image"
            height="200px"
          ></v-img>
          <h3 class="primary--text my-2">
            {{ detail.title }}
          </h3>
          <p class="paragraph line-clamp-4">
            {{ detail.content }}
          </p>
          <span class="clickable primary--text">Read More</span>
        </v-card>
      </v-slide-item>
    </v-slide-group>
  </v-sheet>
</template>

<script>
  export default {
    name: 'SliderCard',

    props: {
      details: { type: Array }
    }
  }
</script>

<style lang="scss" scoped>
.paragraph {
  color: #666666;
  font-size: 15px;
}
</style>